import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
} from "@mui/material";
import { useState, useEffect } from "react";
import { post } from "../../../../utils/api";
import BulkFileUpload from "../../../Scope1/FugitiveEmmissions/BulkFileUpload";

const RoadBulkUpload = ({
  matchData,
  onClose,
  onConfirm,
  bulkUploadTable,
  bulkuploadInputData,
  url,
  title1,
  title2,
  title3,
  keyValue1,
  keyValue2,
  keyValue3,
  options1,
  options2,
  options3,
  matched1,
  matched2,
  matched3,
  setFormDataBulkUpload,
  formDataBulkUpload,
  bulkUploadUrl,
  setsnackOpen,
}) => {
  const [optionList1, setOptionList1] = useState([]);
  const [optionList2, setOptionList2] = useState([]);
  const [optionList3, setOptionList3] = useState([]);

  // Document upload state management
  const [documentUploadConfirmed, setDocumentUploadConfirmed] = useState(false);
  const [documentUploadType, setDocumentUploadType] = useState("none"); // "none", "individual", "same"
  const [commonDocument, setCommonDocument] = useState(null);
  const [individualDocuments, setIndividualDocuments] = useState({});
  const [uploadValidationErrors, setUploadValidationErrors] = useState([]);
  const [hasValidationBeenAttempted, setHasValidationBeenAttempted] =
    useState(false);

  console.log(matchData, "matchData");
  useEffect(() => {
    if (options1) {
      setOptionList1(options1);
    }
    if (options2) {
      setOptionList2(options2);
    }
    if (options3) {
      setOptionList3(options3);
    }
  }, [options1, options2, options3]);

  if (!matchData || matchData.length === 0) {
    return null;
  }

  console.log(matchData, "matchData");

  // Document upload handler functions
  const handleDocumentUploadConfirmation = (confirmed) => {
    setDocumentUploadConfirmed(confirmed);

    if (!confirmed) {
      // Reset document upload type to "none" if user chooses not to upload
      setDocumentUploadType("none");
    }

    // Clear validation errors when user makes a choice about document upload
    setUploadValidationErrors([]);
    setHasValidationBeenAttempted(false);
  };

  const handleDocumentUploadTypeChange = (event) => {
    setDocumentUploadType(event.target.value);

    setCommonDocument(null);
    setIndividualDocuments({});

    // Clear validation errors when a valid upload type is selected
    if (event.target.value !== "none") {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleCommonDocumentChange = (files) => {
    setCommonDocument(files);

    // Update formDataBulkUpload with common document for all entries
    if (formDataBulkUpload && formDataBulkUpload.length > 0) {
      const updated = formDataBulkUpload.map((entry) => ({
        ...entry,
        "Document (optional)": files,
      }));
      setFormDataBulkUpload(updated);
    }

    // Clear validation errors when documents are uploaded
    if (files && files.length > 0) {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleIndividualDocumentChange = (index, files) => {
    const filesArray = Array.isArray(files)
      ? files
      : Object.values(files || {});

    setIndividualDocuments((prev) => ({
      ...prev,
      [index]: filesArray,
    }));

    // Update formDataBulkUpload with individual document for specific entry
    if (formDataBulkUpload && formDataBulkUpload.length > 0) {
      const updated = formDataBulkUpload.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": filesArray,
          };
        }
        return entry;
      });
      setFormDataBulkUpload(updated);
    }

    // Clear validation errors when documents are uploaded
    if (filesArray.length > 0) {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleCommonDocumentClear = () => {
    setCommonDocument(null);

    // Update formDataBulkUpload to clear common document for all entries
    if (formDataBulkUpload && formDataBulkUpload.length > 0) {
      const updated = formDataBulkUpload.map((entry) => ({
        ...entry,
        "Document (optional)": null,
      }));
      setFormDataBulkUpload(updated);
    }
  };

  const handleIndividualDocumentClear = (index) => {
    setIndividualDocuments((prev) => {
      const newDocs = { ...prev };
      delete newDocs[index];
      return newDocs;
    });

    // Update formDataBulkUpload to clear individual document for specific entry
    if (formDataBulkUpload && formDataBulkUpload.length > 0) {
      const updated = formDataBulkUpload.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": null,
          };
        }
        return entry;
      });
      setFormDataBulkUpload(updated);
    }
  };

  const validateUploadData = () => {
    const validationErrors = [];

    // Check if user wants to upload documents but hasn't uploaded any
    if (documentUploadConfirmed && documentUploadType === "none") {
      validationErrors.push(
        "Please select a document upload type when document upload is confirmed.",
      );
    }

    return validationErrors;
  };

  const performUpload = async () => {
    const dataToUse =
      formDataBulkUpload && formDataBulkUpload.length > 0
        ? formDataBulkUpload
        : bulkuploadInputData;

    // Prepare data structure for upload
    const uploadData = {
      excelData: dataToUse,
      documentUploadType: documentUploadType,
      commonDocument: commonDocument,
      individualDocuments: individualDocuments,
    };

    console.log("Final upload data structure:", uploadData);

    if (bulkUploadUrl) {
      await post(bulkUploadUrl, uploadData)
        .then((res) => {
          // Clear validation errors and reset validation attempted flag on successful upload
          setUploadValidationErrors([]);
          setHasValidationBeenAttempted(false);
          setsnackOpen({
            open: true,
            message: res.data.message,
            severity: "success",
          });
          onConfirm();
          onClose();
        })
        .catch((err) => {
          const errMessage = err.response?.data?.details
            ?.map((el) => el?.error)
            ?.join(",");
          if (err?.response?.status === 422) {
          }
          setsnackOpen({
            open: true,
            message:
              errMessage ?? err.response?.data?.message ?? "Network Error",
            severity: "error",
          });
        });
    } else {
      // Fallback to original onConfirm if no bulkUploadUrl provided
      onConfirm();
    }
  };

  const handleSubmit = async () => {
    // Mark that validation has been attempted
    setHasValidationBeenAttempted(true);

    // Validate upload data
    const validationErrors = validateUploadData();
    setUploadValidationErrors(validationErrors);

    // If there are validation errors, don't proceed
    if (validationErrors.length > 0) {
      return;
    }

    // Proceed with upload
    await performUpload();
  };

  const handleFormChange = (index, field, value) => {
    setFormDataBulkUpload((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value,
      },
    }));
    console.log(formDataBulkUpload, "formDataBulkUpload");
  };

  return (
    <Dialog
      open={bulkUploadTable}
      onClose={onClose}
      maxWidth="lg"
      sx={{
        "& .MuiDialog-paper": {
          width: "80%",
          margin: "16px",
          maxHeight: "calc(100% - 32px)",
          zIndex: 1000,
        },
      }}
    >
      <DialogTitle>Review Bulk Upload Data</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Review the matched and unmatched equipment data. Add unmatched items
          individually.
        </Typography>

        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
            <TableHead sx={{ overflowX: "hidden" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                  Data Entered
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", width: "10%" }}
                ></TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", width: "10%" }}
                ></TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                  Master Data
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", width: "15%" }}
                ></TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", width: "15%" }}
                ></TableCell>
                {documentUploadConfirmed &&
                  documentUploadType === "individual" && (
                    <TableCell sx={{ fontWeight: "bold", width: "10%" }}>
                      Document
                    </TableCell>
                  )}
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    width: title2 ? "20%" : title3 ? "29%" : "50%",
                  }}
                >
                  {title1 ? title1 : "Equipment Name"}
                </TableCell>
                {title2 && (
                  <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                    {title2 ? title2 : "Equipment Name"}
                  </TableCell>
                )}
                {title3 && (
                  <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                    {title3 ? title3 : "Equipment Name"}
                  </TableCell>
                )}
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    width: title2 ? "15%" : title3 ? "29%" : "50%",
                  }}
                >
                  {title1 ? title1 : "Equipment Name"}
                </TableCell>
                {title2 && (
                  <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                    {title2 ? title2 : "Equipment Name"}
                  </TableCell>
                )}
                {title3 && (
                  <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                    {title3 ? title3 : "Equipment Name"}
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {matchData.map((item, index) => (
                <>
                  <TableRow key={index}>
                    <TableCell>
                      {keyValue1 ? item?.[keyValue1] : item.equipment}
                    </TableCell>
                    {title2 && (
                      <TableCell>
                        {keyValue2 ? item?.[keyValue2] : item.equipment}
                      </TableCell>
                    )}

                    {title3 && (
                      <TableCell>
                        {keyValue3 ? item?.[keyValue3] : item.equipment}
                      </TableCell>
                    )}
                    <TableCell>
                      {item[matched1] ? (
                        <Chip label="Matched" color="success" size="small" />
                      ) : (
                        <FormControl
                          size="small"
                          sx={{
                            minWidth: title2
                              ? "7.5rem"
                              : title3
                                ? "15.5rem"
                                : "20rem",
                            maxWidth: title2
                              ? "7.5rem"
                              : title3
                                ? "15.5rem"
                                : "20rem",
                          }}
                        >
                          <Select
                            value={formDataBulkUpload[index]?.[title1] || ""}
                            onChange={(e) =>
                              handleFormChange(index, title1, e.target.value)
                            }
                            fullWidth
                            displayEmpty
                            disabled={item[matched1]}
                            sx={{
                              minWidth: title2
                                ? "7.5rem"
                                : title3
                                  ? "15.5rem"
                                  : "20rem",
                              maxWidth: title2
                                ? "7.5rem"
                                : title3
                                  ? "15.5rem"
                                  : "20rem",
                            }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  width: title2
                                    ? "7.5rem"
                                    : title3
                                      ? "15.5rem"
                                      : "20rem",
                                },
                              },
                            }}
                          >
                            <MenuItem value="">Tap to Select</MenuItem>
                            {optionList1 &&
                              optionList1.map((item, index) => {
                                return <MenuItem value={item}>{item}</MenuItem>;
                              })}
                          </Select>
                        </FormControl>
                      )}
                    </TableCell>
                    {title2 && (
                      <TableCell>
                        {item[matched2] ? (
                          <Chip label="Matched" color="success" size="small" />
                        ) : (
                          <FormControl
                            size="small"
                            sx={{ minWidth: "10rem", maxWidth: "10rem" }}
                          >
                            <Select
                              value={
                                formDataBulkUpload[index]?.[keyValue2] || ""
                              }
                              onChange={(e) =>
                                handleFormChange(
                                  index,
                                  keyValue2,
                                  e.target.value,
                                )
                              }
                              fullWidth
                              displayEmpty
                              disabled={item[matched2]}
                              sx={{ minWidth: "10rem", maxWidth: "10rem" }}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    width: "10rem",
                                  },
                                },
                              }}
                            >
                              <MenuItem value="">Tap to Select</MenuItem>
                              {optionList2 &&
                                optionList2.map((item, index) => {
                                  return (
                                    <MenuItem value={item}>{item}</MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        )}
                      </TableCell>
                    )}
                    {title3 && (
                      <TableCell>
                        {item[matched3] ? (
                          <Chip label="Matched" color="success" size="small" />
                        ) : (
                          <FormControl
                            size="small"
                            sx={{ minWidth: "10rem", maxWidth: "10rem" }}
                          >
                            <Select
                              value={
                                formDataBulkUpload[index]?.[keyValue3] || ""
                              }
                              onChange={(e) =>
                                handleFormChange(
                                  index,
                                  keyValue3,
                                  e.target.value,
                                )
                              }
                              fullWidth
                              displayEmpty
                              disabled={item[matched3]}
                              sx={{ minWidth: "10.5rem", maxWidth: "10.5rem" }}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    width: "10.5rem",
                                  },
                                },
                              }}
                            >
                              <MenuItem value="">Tap to Select</MenuItem>
                              {optionList3 &&
                                optionList3.map((item, index) => {
                                  return (
                                    <MenuItem value={item}>{item}</MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        )}
                      </TableCell>
                    )}
                    {documentUploadConfirmed &&
                      documentUploadType === "individual" && (
                        <TableCell>
                          <BulkFileUpload
                            filesList={individualDocuments[index] || []}
                            handleChange={handleIndividualDocumentChange}
                            handleClear={handleIndividualDocumentClear}
                            index={index}
                          />
                        </TableCell>
                      )}
                  </TableRow>
                  {/* Expandable form row */}
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Document Upload Section */}
        <Box sx={{ mt: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Document Upload
          </Typography>
          <Box>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Do you want to upload document?
              </FormLabel>
              <RadioGroup
                value={documentUploadConfirmed ? "yes" : "no"}
                onChange={(e) =>
                  handleDocumentUploadConfirmation(e.target.value === "yes")
                }
                row
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Box>
          {documentUploadConfirmed && (
            <FormControl component="fieldset" sx={{ mb: 2, mt: 2 }}>
              <FormLabel component="legend">Document Upload Type</FormLabel>
              <RadioGroup
                value={documentUploadType}
                onChange={handleDocumentUploadTypeChange}
                row
              >
                <FormControlLabel
                  value="same"
                  control={<Radio />}
                  label="Same File for All Records"
                />
                <FormControlLabel
                  value="individual"
                  control={<Radio />}
                  label="Individual File for Each Record"
                />
              </RadioGroup>
            </FormControl>
          )}

          {documentUploadConfirmed && documentUploadType === "same" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Upload Common Document:
              </Typography>
              <BulkFileUpload
                handleChange={handleCommonDocumentChange}
                handleClear={handleCommonDocumentClear}
                filesList={commonDocument}
              />
            </Box>
          )}

          {documentUploadConfirmed && documentUploadType === "individual" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Upload individual documents for each record. Documents will be
                added as a new column in the table above.
              </Typography>
            </Box>
          )}

          {/* Display validation errors */}
          {hasValidationBeenAttempted && uploadValidationErrors.length > 0 && (
            <Box sx={{ mt: 2 }}>
              {uploadValidationErrors.map((error, index) => (
                <Typography
                  key={index}
                  sx={{ color: "error.main", fontSize: "0.875rem" }}
                >
                  {error}
                </Typography>
              ))}
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "1rem" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          sx={{ marginRight: "1rem" }}
        >
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Confirm Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RoadBulkUpload;
